import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'photos',
    label: i18n('entities.eLabel.fields.photos'),
    schema: schemas.images(i18n('entities.eLabel.fields.photos'), {
      required: true,
    }),
  },
  {
    name: 'porductTitle',
    label: i18n('entities.eLabel.fields.porductTitle'),
    schema: schemas.string(i18n('entities.eLabel.fields.porductTitle'), {
      required: true,
      min: 3,
    }),
  },
  {
    name: 'productSubtitle',
    label: i18n('entities.eLabel.fields.productSubtitle'),
    schema: schemas.string(i18n('entities.eLabel.fields.productSubtitle'), {}),
  },
  {
    name: 'productDescription',
    label: i18n('entities.eLabel.fields.productDescription'),
    schema: schemas.string(
      i18n('entities.eLabel.fields.productDescription'),
      {},
    ),
  },
  {
    name: 'productType',
    label: i18n('entities.eLabel.fields.productType'),
    schema: schemas.string(i18n('entities.eLabel.fields.productType'), {
      required: true,
      min: 2,
    }),
  },
  {
    name: 'productVolume',
    label: i18n('entities.eLabel.fields.productVolume'),
    schema: schemas.string(i18n('entities.eLabel.fields.productVolume'), {
      required: true,
    }),
  },
  {
    name: 'producer',
    label: i18n('entities.eLabel.fields.producer'),
    schema: schemas.relationToOne(i18n('entities.eLabel.fields.producer'), {
      required: true,
    }),
  },
  {
    name: 'ingredients',
    label: i18n('entities.eLabel.fields.ingredients'),
    schema: schemas.string(i18n('entities.eLabel.fields.ingredients'), {
      required: true,
      min: 5,
    }),
  },
  {
    name: 'nutritionInformation',
    label: i18n('entities.eLabel.fields.nutritionInformation'),
    schema: schemas.relationToOne(
      i18n('entities.eLabel.fields.nutritionInformation'),
      {
        required: true,
      },
    ),
  },
  {
    name: 'sustainability',
    label: i18n('entities.eLabel.fields.sustainability'),
    schema: schemas.relationToOne(
      i18n('entities.eLabel.fields.sustainability'),
      {
        required: true,
      },
    ),
  },
  {
    name: 'packagingCertification',
    label: i18n('entities.eLabel.fields.packagingCertification'),
    schema: schemas.relationToOne(
      i18n('entities.eLabel.fields.packagingCertification'),
      {
        required: true,
      },
    ),
  },
  {
    name: 'recyclingMaterials',
    label: i18n('entities.eLabel.fields.recyclingMaterials'),
    schema: schemas.relationToOne(
      i18n('entities.eLabel.fields.recyclingMaterials'),
      {
        required: true,
      },
    ),
  },
  {
    name: 'foodOperator',
    label: i18n('entities.eLabel.fields.foodOperator'),
    schema: schemas.relationToMany(
      i18n('entities.eLabel.fields.foodOperator'),
      {},
    ),
  },
  {
    name: 'productEan',
    label: i18n('entities.eLabel.fields.productEan'),
    schema: schemas.string(i18n('entities.eLabel.fields.productEan'), {}),
  },
  {
    name: 'responsibleConsumption',
    label: i18n('entities.eLabel.fields.responsibleConsumption'),
    schema: schemas.relationToOne(
      i18n('entities.eLabel.fields.responsibleConsumption'),
      {},
    ),
  },
  {
    name: 'language',
    label: i18n('entities.eLabel.fields.language'),
    schema: schemas.string(i18n('entities.eLabel.fields.language'), {
      required: true,
    }),
  },
];
